// @ts-check

/**
 * @file Initializes TensorBuzz bug reporting for the frontend runtime.
 */

import {BugReporting} from "tensorbuzz-api"

import secrets from "../config/secrets"

let initialized = false

/**
 * Initializes browser and Expo error reporting when configured.
 * @returns {BugReporting | null} Reporter instance when enabled.
 */
export default function initializeTensorBuzzBugReporting() {
  if (initialized) return null
  initialized = true

  const settings = secrets.tensorbuzzBugReporting

  if (!settings?.authToken) return null

  const runtimeEnvironment = settings.runtimeEnvironment || "frontend"
  const reporter = new BugReporting({
    authToken: settings.authToken,
    hostname: settings.hostname || null,
    postUrl: settings.postUrl || null,
    runtimeEnvironment
  })

  reporter.collectEnvironment(() => ({
    app: "awesome-tasks",
    release: settings.release || null,
    runtime: runtimeEnvironment
  }))

  reporter.enableSourceMapsLoader()
  reporter.connect()

  return reporter
}
